var map = {
	"./en/4-2/4_2tit.png": 79692,
	"./fi/4-2/4_2tit.png": 10074,
	"./in/4-2/4_2tit.png": 19736,
	"./th/4-2/4_2tit.png": 99903,
	"./tw/4-2/4_2tit.png": 44222,
	"./zh/4-2/4_2tit.png": 72205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16418;